import { generateMedia } from "styled-media-query";
 
const customMedia = generateMedia({
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px"
});
 

export default customMedia;